import { GOVGR_HINT } from "../../conf/styles/GovGrDate";

const Hint = ({
  disabled,
  hint,
  disabledMessage = "Το πεδίο δε μπορεί να τροποποιηθεί",
}) => {
  if (!disabled && !hint) {
    return `\u00A0`;
  }

  return (
    <p className={`${GOVGR_HINT} mt-2`}>
      {!!disabled ? disabledMessage : hint}
    </p>
  );
};

export default Hint;
